module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('img', {
    staticClass: "img-link",
    attrs: {
      "src": "static/img/home.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Principal")])])]), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(5)) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/orders"
    }
  }, [_c('a', [_c('img', {
    staticClass: "img-link",
    attrs: {
      "src": "/static/img/welcome-bag.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Órdenes de compra")])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(5)) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/warehouse"
    }
  }, [_c('a', [_c('img', {
    staticClass: "img-link",
    attrs: {
      "src": "/static/img/welcome-bag.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Warehouse")])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(5)) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/categorys"
    }
  }, [_c('a', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "gap": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    staticStyle: {
      "font-size": "1.5rem"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Categorias")])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(5)) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/subpartida"
    }
  }, [_c('a', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "gap": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    staticStyle: {
      "font-size": "1.5rem"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Subpartida")])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(12)) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/shipments"
    }
  }, [_c('a', [_c('img', {
    staticClass: "img-link",
    attrs: {
      "src": "/static/img/welcome-ship.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Embarques")])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(14)) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/users"
    }
  }, [_c('a', [_c('img', {
    staticClass: "img-link",
    attrs: {
      "src": "/static/img/welcome-users.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Usuarios")])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(14)) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cotizaciones"
    }
  }, [_c('a', [_c('img', {
    staticClass: "img-link",
    attrs: {
      "src": "/static/img/cliente.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Cotizaciones")])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(14)) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/Reclamaciones"
    }
  }, [_c('a', [_c('img', {
    staticClass: "img-link",
    attrs: {
      "src": "/static/img/information.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Reclamaciones")])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(14)) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/tableRebate"
    }
  }, [_c('a', [_c('img', {
    staticClass: "img-link",
    attrs: {
      "src": "/static/img/administrador.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Utils")])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(14)) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/credenciales"
    }
  }, [_c('a', [_c('img', {
    staticClass: "img-link",
    attrs: {
      "src": "/static/img/administrador.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Credenciales")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page inferior"
  }, [_vm._m(0), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tamanoLetra"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.data.buy : ""))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tamanoLetra"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.data.sale : ""))])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "tamanoLetra"
  }, [_vm._v("Compra:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "page tamanoLetra"
  }, [_vm._v("Venta:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08378435"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/SidebarMenu.vue
// module id = 1847
// module chunks = 1